"use strict";

exports.__esModule = true;
exports.convertSearchObjectToSearchResult = void 0;

/* eslint-disable camelcase */
const convertSearchObjectToSearchResult = ({
  id,
  url,
  title,
  description,
  sku,
  image_url,
  image_title,
  image_data,
  barcode_number,
  brand_name,
  segment_description,
  aroma_scent,
  net_content_statement
}) => ({
  id,
  sku,
  title,
  description,
  url,
  image: {
    url: image_url,
    title: image_title,
    data: JSON.parse(image_data)
  },
  barcodeNumber: barcode_number,
  brandName: brand_name,
  segmentDescription: segment_description,
  aromaScent: aroma_scent,
  netContentStatement: net_content_statement
});

exports.convertSearchObjectToSearchResult = convertSearchObjectToSearchResult;